const page = "CartPage";

export default page;
